import { RefreshButton } from 'sharedUi/RefreshButton';

interface ListCountProps {
  /** Total rows the server reports — not the page length. */
  total?: number | null;
  onRefresh: () => void;
  /** Spins the button; pass the query's fetching flag, not its initial loading one. */
  loading?: boolean;
  testId?: string;
}

/**
 * The standard right-hand end of a list toolbar: how many rows there are, and a
 * way to refetch them.
 *
 * The two belong together. A count with no refresh goes stale with no way to
 * correct it, and a refresh with no count gives no sign that anything happened
 * when the data has not changed. Several lists had written the pair inline and
 * drifted — different wording, different greys, singular "1 records" — so it
 * lives here once.
 *
 * Render it INSIDE a list's `toolbarEnd`, before any primary action, so Create
 * stays the rightmost thing on every screen:
 *
 *   toolbarEnd={<><ListCount total={q.data?.total} onRefresh={q.refetch} /> {canCreate && <Button … />}</>}
 */
export const ListCount = ({ total, onRefresh, loading = false, testId }: ListCountProps) => {
  const n = total ?? 0;
  return (
    <>
      <span className="text-sm text-gray-400 dark:text-gray-500 whitespace-nowrap">
        {n.toLocaleString()} {n === 1 ? 'record' : 'records'}
      </span>
      <RefreshButton onClick={onRefresh} loading={loading} testId={testId} />
    </>
  );
};

export default ListCount;
